import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider } from 'rmwc/List';
import {default as Reactsel} from 'react-select';
import StarRatings from 'react-star-ratings';
import { ListItemGraphic} from 'rmwc/List';
import ReactTooltip from 'react-tooltip'

class AboutCentaMC extends Component {
	constructor(props) {
		super(props)
    	this.state = {
    		question: '',
    		activeDiv: 0
    	}
	}

	handleQuestion = (e, value) => {
		this.setState({activeDiv: value})
	}

	handleRegister = (e) => {
		this.props.history.push('/portal/app/mc_registration')
	}
	
	handleTPOJump = (e) => {
		this.props.history.push('/portal/app/user/about/tpo')
	}

	handleTQJump = (e) => {
		this.props.history.push('/portal/app/user/about/tq')
	}

	handleMCJump = (e) => {
		this.props.history.push('/portal/app/user/about/mc')
	}

	render() {
		let handleQuestion = this.handleQuestion
		let handleRegister = this.handleRegister
		let handleTPOJump = this.handleTPOJump
		let handleTQJump = this.handleTQJump
		let handleMCJump = this.handleMCJump
		let mcLogo = 'https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/artifacts/FC_MC_logo%20green.png'
		return (
			<div>
				<Grid>
					<GridCell span = "2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleTPOJump(e))}>CENTA TPO</Button>
					</GridCell>
					<GridCell span = "3">
					</GridCell>
					<GridCell span = "2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleTQJump(e))}>CENTA TQ</Button>
					</GridCell>
					<GridCell span = "3">
					</GridCell>
					<GridCell span = "2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleMCJump(e))}>CENTA MC</Button>
					</GridCell>
					<GridCell span="12">
					</GridCell>
					<GridCell span="4">
					</GridCell>
					<GridCell span="4">
						<img className ="mcLogo" src={mcLogo} alt="logo" />
					</GridCell>
					<GridCell span="4">
					</GridCell>
					<GridCell span="5">
					</GridCell>
					<GridCell span="2">
						<Button raised theme="secondary-bg on-secondary" onClick = {((e) => handleRegister(e))}>Register</Button>
					</GridCell>
					<GridCell span="5">
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 1))}>
							<Typography use="headline7"><b>What is CENTA Certification?</b></Typography>
							<div className={ this.state.activeDiv === 1 ? "showdiv" : "hidediv"} >
							  	<p>
							  		A certification for Grade 1 to 12 teachers, CENTA Certification is a high-quality assessment of teaching competencies. It is structured as five micro-credentials and is based on the internationally bench-marked CENTA Standards.
							  	</p>
							</div>
						</Card>
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 2))}>
							<Typography use="headline7"><b>Which are the five micro-credentials that constitute CENTA Certification?</b></Typography>
							<div className={ this.state.activeDiv === 2 ? "showdiv" : "hidediv"} >
							  	<p>
							  		<table>
							  			<th></th>
							  			<th>CENTA Micro-Credential</th>
							  			<th>What it assesses</th>
							  			<tr>
							  				<td>1</td>
							  				<td><b>Subject Expertise</b></td>
							  				<td>Subject knowledge, Conceptual understanding and ability to relate topics through real-life examples</td>
							  			</tr>
							  			<tr>
							  				<td>2</td>
							  				<td><b>Classroom Communication</b></td>
							  				<td>Ability to teach through pedagogical methods and resources aligned with learning objectives, in different classroom settings (including online teaching-learning)</td>
							  			</tr>
							  			<tr>
							  				<td>3</td>
							  				<td><b>Content Development and Planning</b></td>
							  				<td>Understanding of and ability to develop content and lesson plans, considering appropriate sequence of topics and right pedagogical methods and resources</td>
							  			</tr>
							  			<tr>
							  				<td>4</td>
							  				<td><b>Student Assessment and Remediation</b></td>
							  				<td>Knowledge of purpose and tools of assessments; ability to design appropriate assessments depending upon their objective, derive generic and student specific insights and develop appropriate remedial steps</td>
							  			</tr>
							  			<tr>
							  				<td>5</td>
							  				<td><b>Professional Competencies</b></td>
							  				<td>Self-development, ability to interact and build relationships with peers, students, parents and community, problem solving, work planning and time management, communication skills</td>
							  			</tr>
							  		</table>
							  	</p>
							</div>
						</Card>
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 3))}>
							<Typography use="headline7"><b>What is the benefit of taking up CENTA Certification?</b></Typography>
							<div className={ this.state.activeDiv === 3 ? "showdiv" : "hidediv"} >
							  	<p>
							  		Several schools and school groups use the CENTA Certification and Micro-Credentials in teacher recruitment, internal promotions and for supplemental roles. In case you are a teacher, you can use CENTA Certification to access outstanding opportunities, enhance career growth and get inputs on your professional development.
							  	</p>
							</div>
						</Card>
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 4))}>
							<Typography use="headline7"><b>What is the process of taking up CENTA Certification?</b></Typography>
							<div className={ this.state.activeDiv === 4 ? "showdiv" : "hidediv"} >
							  	<p>
							  		The entire process is online, so candidates can pursue it from anywhere. Assessments involve a mix of remotely proctored test (with pre-announced slots) and submissions into an e-portfolio system.
							  	</p>
							</div>
						</Card>
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 5))}>
							<Typography use="headline7"><b>Which are the levels that each Micro-Credential is available in?</b></Typography>
							<div className={ this.state.activeDiv === 5 ? "showdiv" : "hidediv"} >
							  	<ul>
									<li>Level 1: Typically relevant for teachers with 0-3 years of experience</li>
									<li>Level 2: Typically relevant for teachers with 3-10 years of experience</li>
									<li>Level 3: Typically relevant for teachers with more than 10 years of experience</li>
								</ul>
							</div>
						</Card>
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 6))}>
							<Typography use="headline7"><b>Which are the subjects in which I can take up CENTA Certification?</b></Typography>
							<div className={ this.state.activeDiv === 6 ? "showdiv" : "hidediv"} >
								<p>
									CENTA Certification is currently available in 20 subject tracks: Primary (mix of Language, Maths and EVS available in English, Hindi, Marathi, Tamil and Telugu currently), Middle School English, Middle School Maths, Middle School Science, Middle School Social Studies, Secondary School English, Senior Secondary English, Secondary School Maths, Senior Secondary Maths, Secondary School Physics, Senior Secondary Physics, Secondary School Chemistry, Senior Secondary Chemistry, Secondary School Biology, Senior Secondary Biology and Senior Secondary Economics.
								</p>
							</div>
						</Card>
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 7))}>
							<Typography use="headline7"><b>Subject Expertise Micro-Credential</b></Typography>
							<div className={ this.state.activeDiv === 7 ? "showdiv" : "hidediv"} >
							  	<p>
							  		<b>Competencies assessed</b>
							  		<ol>
							  			<li>
							  				Subject Expertise
							  				<ul>
							  					<li>Knowledge of content and procedures of the subject chosen</li>
							  					<li>Conceptual understanding of different topics of the subject</li>
							  					<li>Ability to explain different topics using appropriate real-life examples</li>
							  					<li>Understanding of purpose of the subject</li>
							  				</ul>
							  			</li>
							  			<li>Basic verbal and written communication for all levels</li>
							  		</ol>
							  		<b>Instruments used to assess</b>
							  		<ol>	
							  			<li>One remotely proctored test (2 to 3 hours)</li>
							  			<li>Two self-videos on given topics, for 1-2 minutes each</li>
							  		</ol>
							  		For more details on the competencies assessed and instruments used, please <a href = "https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/artifacts/Subject_Expertise.pdf" target="_blank" style={{cursor: 'pointer'}}>Click here</a>.
							  	</p>
							</div>
						</Card>
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 8))}>
							<Typography use="headline7"><b>Classroom Communication Micro-Credential</b></Typography>
							<div className={ this.state.activeDiv === 8 ? "showdiv" : "hidediv"} >
						  		<p>
						  			<b>Competencies assessed</b>
							  		<ol>
							  			<li>
							  				Classroom Management
							  				<ul>
							  					<li>Understanding of common classroom management techniques for involvement, positive disciplining, addressing diversity in learning needs etc. in the type of classroom setting</li>
							  					<li>Organization of the classroom to creative conducive learning environment</li>
							  					<li>Teaching the topic using pedagogical methods and resources aligned with teaching-learning objectives</li>
							  					<li>Teaching with relatable examples, including using student experiences when relevant</li>
							  					<li>Spending the time of the class productively and making learning participatory</li>
							  					<li>Theories related to how children learn and how learning connections are made with age</li>
							  					<li>Understanding of the diversity in learner characteristics and learning patterns</li>
							  				</ul>
							  			</li>
							  			<li>Verbal Communication</li>
							  			<li>Basic Subject Knowledge, Understanding and Application</li>
							  		</ol>
							  		<b>Instruments used to assess</b>
							  		<ol>	
							  			<li>One remotely proctored test (2 to 3 hours)</li>
							  			<li>One Teaching Demo Video (15-20 minutes)</li>
							  			<li>Two self-videos on given topics, for 1-2 minutes each</li>
							  			<li>Two Classroom Live videos (15 minutes each) – only for Level 2 and Level 3</li>
							  		</ol>
							  		For more details on the competencies assessed and instruments used, please <a href = "https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/artifacts/Classroom_Communication.pdf" target="_blank" style={{cursor: 'pointer'}}>Click here</a>.
								</p>
						  	</div>
						</Card>
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 9))}>
							<Typography use="headline7"><b>Content Development and Planning Micro-Credential</b></Typography>
							<div className={ this.state.activeDiv === 9 ? "showdiv" : "hidediv"} >
						  		<p>
						  			<b>Competencies assessed</b>
							  		<ol>
							  			<li>
							  				Content Development
							  				<ul>
							  					<li>Knowledge of different types of planning resources, and the process to create each</li>
							  					<li>Understanding of a well-written learning objective, specific competencies it is referring to and general and subject-specific pedagogical methods and resources</li>
							  					<li>Theories related to how children learn and how learning connections are made with age</li>
							  					<li>Understanding of the diversity in learner characteristics and learning patterns</li>
							  					<li>Understanding of and ability to use common technologies and ICT resources for teaching learning process</li>
							  				</ul>
							  			</li>
							  			<li>Written Communication</li>
							  			<li>Basic Subject Knowledge, Understanding and Application and basic verbal communication</li>
							  		</ol>
							  		<b>Instruments used to assess</b>
							  		<ol>	
							  			<li>Two remotely proctored test (2 to 3 hours)</li>
							  			<li>Two self-videos on given topics, for 1-2 minutes each</li>
							  		</ol>
							  		For more details on the competencies assessed and instruments used, please <a href = "https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/artifacts/Content_Development_and_Planning.pdf" target="_blank" style={{cursor: 'pointer'}}>Click here</a>.
								</p>
						  	</div>
						</Card>
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 10))}>
							<Typography use="headline7"><b>Student Assessment and Remediation Micro-Credential</b></Typography>
							<div className={ this.state.activeDiv === 10 ? "showdiv" : "hidediv"} >
						  		<p>
						  			<b>Competencies assessed</b>
							  		<ol>
							  			<li>
							  				Assessment and Remediation
							  				<ul>
							  					<li>Understanding of assessment objectives, methods and tools</li>
							  					<li>Ability to select/ modify an assessment, considering the assessment objectives and the classroom context</li>
							  					<li>Analyze assessment results (qualitative and quantitative), derive insights on common and student specific misconceptions and identify appropriate teaching strategies</li>
							  					<li>Communicate feedback on specific misconceptions</li>
							  				</ul>
							  			</li>
							  			<li>Basic Subject Knowledge, Understanding and Application</li>
							  			<li>Basic written and verbal communication</li>
							  		</ol>
							  		<b>Instruments used to assess</b>
							  		<ol>	
							  			<li>Two remotely proctored test (2 to 3 hours)</li>
							  			<li>Two self-videos on given topics, for 1-2 minutes each</li>
							  		</ol>
							  		For more details on the competencies assessed and instruments used, please <a href = "https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/artifacts/Student_Assessment_and_Remediation.pdf" target="_blank" style={{cursor: 'pointer'}}>Click here</a>.
								</p>
						  	</div>
						</Card>
					</GridCell>
					<GridCell span="12">
						<Card style={{padding: '10px'}} onClick={((e) => handleQuestion(e, 11))}>
							<Typography use="headline7"><b>Professional Competencies Micro-Credential</b></Typography>
							<div className={ this.state.activeDiv === 11 ? "showdiv" : "hidediv"} >
						  		<p>
						  			NOT subject specific; it is also currently available ONLY for Level 2 and Level 3.
						  			<b>Competencies assessed</b>
					  				<ul>
					  					<li>Self-Development</li>
					  					<li>Teamwork, Leadership and Coaching</li>
					  					<li>Relationship with Students</li>
					  					<li>Interaction with Parents and Community</li>
					  					<li>Work Planning and Time Management</li>
					  					<li>Understanding of Policies and Student Safety</li>
					  					<li>Problem Solving Ability</li>
					  					<li>Verbal and Written Communication</li>
					  					<li>Technological Awareness</li>
					  				</ul>
							  		<b>Instruments used to assess</b>
							  		<ol>	
							  			<li>Two remotely proctored test (2 to 3 hours)</li>
							  			<li>Detailed information on Professional Development and Knowledge Sharing related initiatives taken up by the candidate – to be submitted in pre-defined format</li>
							  			<li>Two self-videos on given topics, for 1-2 minutes each</li>
							  			<li>Video Interview by an Expert Assessor</li>
							  			<li>Surveys of Principal, Sample Peers, Sample Parents and Sample Students</li>
							  		</ol>
							  		For more details on the competencies assessed and instruments used, please <a href = "https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/artifacts/Professional_Competencies.pdf" target="_blank" style={{cursor: 'pointer'}}>Click here</a>.
								</p>
						  	</div>
						</Card>
					</GridCell>
				</Grid>
			</div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutCentaMC);


// WEBPACK FOOTER //
// ./src/views/about/AboutCentaMC.jsx